"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousRequestService = void 0;
var lodash_1 = require("lodash");
var Enums_1 = require("../Core/Http/Enums");
var responseMessageToString_1 = require("../utils/responseMessageToString");
var ServiceRequest_1 = require("./ServiceRequest");
var AnonymousRequestService = /** @class */ (function () {
    function AnonymousRequestService(clientId, endpoint) {
        this._clientId = clientId;
        this._endpoint = endpoint;
    }
    Object.defineProperty(AnonymousRequestService.prototype, "endpoint", {
        get: function () {
            return this._endpoint;
        },
        enumerable: false,
        configurable: true
    });
    AnonymousRequestService.prototype.handleAnonymousRequest = function (route, extractor, exceptionProducer, payload, routeParams, queryString) {
        if (payload === void 0) { payload = {}; }
        if (routeParams === void 0) { routeParams = {}; }
        if (queryString === void 0) { queryString = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var statusCode, response, responseAsDefault, bringgException;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new ServiceRequest_1.AnonymousServiceRequest(this._clientId)
                            .invoke(this.endpoint, route, routeParams, queryString, payload)
                            .handle(function (response) {
                            var status = response.status, data = response.data;
                            statusCode = status;
                            if (status != Enums_1.HttpStatusCode.OK &&
                                status != Enums_1.HttpStatusCode.CREATED &&
                                status != Enums_1.HttpStatusCode.NO_CONTENT) {
                                (0, ServiceRequest_1.logErrorResponse)(response);
                                throw (0, lodash_1.isFunction)(exceptionProducer) ? exceptionProducer() : response;
                            }
                            return data;
                        })];
                    case 1:
                        response = _a.sent();
                        responseAsDefault = response;
                        if (responseAsDefault.success === false) {
                            bringgException = exceptionProducer();
                            bringgException.details = (0, responseMessageToString_1.responseMessageToString)(responseAsDefault.message);
                            bringgException.rc = responseAsDefault.rc;
                            bringgException.errors = response.errors;
                            bringgException.statusCode = statusCode;
                            throw bringgException;
                        }
                        return [2 /*return*/, extractor(response)];
                }
            });
        });
    };
    return AnonymousRequestService;
}());
exports.AnonymousRequestService = AnonymousRequestService;
//# sourceMappingURL=AnonymousRequestService.js.map